<template>
    <div>
        <v-dialog persistent v-model="dialog" width="1000px">

        <div class="text-center" style="font-family:Sans-serif">
            <center>
                <v-overlay v-model="overlay">
                    <v-progress-circular
                        indeterminate
                        :size="120"
                        :width="3">
                    </v-progress-circular>Loading,please wait...
                </v-overlay>
            </center>
        </div>


        <v-card width="1000px">
            <v-card-title style="background: #455a64; color: white">
            <span class="overline font-weight-black;">CAD依頼添付資料</span>
            </v-card-title>
                <v-card-text>
                    <v-container>
                    <v-card-text>
                        <table class="attachmentViewTable">
                            <thead>
                                <tr>
                                    <th > Column </th>
                                    <th> File Name </th>
                                    <th> File Type </th>
                                    <th> No. of pages </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in previousAttachmentFiles" :key="index">
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''"> {{ item.att_column_name }} </td>
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''"> {{ item.filename }} </td>
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center"> {{ item.fileType }} </td>
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center" v-if="item.no_of_pages != 0"> {{ item.no_of_pages }} </td>
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center" v-else> N/A </td>
                                    <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''">
                                        <v-col>
                                            <v-icon color="primary" @click="viewFile(item.id)">mdi-file-find</v-icon>
                                            <v-icon color="success" @click="downLoadFile(item.id, 'single')">mdi-download-outline</v-icon>
                                            <!-- <v-checkbox v-model="item.selectedCheckBox"  @change="multipleCheckBox(item)"></v-checkbox> -->
                                            <v-checkbox class="mb-0" style="margin-left:15% !important; display:block !important;" v-model="item.selectedCheckBox"  @change="multipleCheckBox(item)"></v-checkbox>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right font-weight-bold" style="height:30px !important;" colspan="3">Total No. of PDF pages attached : </td>
                                    <td class="text-center font-weight-bold">{{ totalPages }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn v-show="repdfBtn" dark color="green" @click="updateCadRequest()" small>結合PDFの作成</v-btn> -->
                        <v-btn dark color="green" v-if="$store.state.editCadRequestRevisionContent.revision_type != '10'" :style="{ 'pointer-events': repdfBtn ? 'none' : 'auto', opacity: repdfBtn ? 0.5 : 1 }" @click="updateMerging()" small>結合PDFの作成</v-btn>
                        <v-btn dark color="blue" v-if="$store.state.editCadRequestRevisionContent.revision_type != '10'" :style="{ 'pointer-events': !downloadBtn ? 'none' : 'auto', opacity: !downloadBtn ? 0.5 : 1 }" small @click="downLoadMultiple()">Download</v-btn>
                        <v-btn dark color="red" small @click="toggleDialogPreviousAttachmentForm(false)"> キャンセル </v-btn>
                    </v-card-actions>
                </v-container>
                </v-card-text>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { PDFDocument } from 'pdf-lib';
import AWS from 'aws-sdk';
import JSZip from 'jszip';
import PlannerTable from '../PlannersTable.vue'
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';
export default {
    props: {
        dialog: Boolean
    },
  data () {
    return {
        env: {
            response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
            request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
        },
        repdfBtn: true,
        downloadBtn: false,
        overlay : false,
        multipleFile : [],
        totalPages : 0,
        attachmentDialog: false,
      // previousAttachment : false,
      // previousAttachmentFiles : [],
      fileAttachments: {
        attachmentFile1: [], //CAD/配置図
        attachmentFile2: [], //現況図（CADデータ）
        attachmentFile3: [], //仕様検討ツール
        attachmentFile4: [], //区画図
        attachmentFile5: [], //吊り上げ重量制限
        attachmentFile6: [], //電気図面/提案電気図面依頼書
        attachmentFile7: [], //電気図面連絡表
        attachmentFile8: [], //施工連絡表
        attachmentFile9: [], //営業本部回答票
        attachmentFile10: [], //その他"
      },
      files : [],
      files1 : [],
      files2 : [],
      files3 : [],
      files4 : [],
      files5 : [],
      files6 : [],
      files7 : [],
      files8 : [],
      files9 : [],
      categories: [
        "CAD/配置図",
        "現況図（CADデータ）",
        "仕様検討ツール",
        "区画図",
        "吊り上げ重量制限",
        "電気図面/提案電気図面依頼書",
        "電気図面連絡表",
        "施工連絡表",
        "営業本部回答票",
        "その他",
      ],
      previews: [],
      errorImage: "url of an image to use to indicate an error",  
      countPageUpdate: 0,
      repdfBtn: false,
      updateRecord : '',
      basicInfo : '',
    }
  },
  computed:{
    ...mapState([
      'attachments',
      'cadRequestRevisionContent',
      'editMode',
      'editCadRequestRevisionContent',
      'previousAttachmentFiles', 
      'cadRequestBasicInformation',
    ]),
  },
  methods: {
    multipleCheckBox(item){
    if(item.selectedCheckBox = true){
        this.multipleFile.push(item)
    }else{
        const index = this.multipleFile.findIndex(obj => obj.id === item.id);
        this.multipleFile.splice(index, 1);
    }
    // this.previousAttachmentFiles.filter((item) => {
    //     if(item.att_column_name == 'CAD依頼書結合ファイル' || item.att_column_name == '現況図（CADデータ）'){
    //         if(item.selectedCheckBox){
    //             this.multipleFile.push(item)
    //         }else{
    //             const index = this.multipleFile.findIndex(obj => obj.id === item.id);
    //             this.multipleFile.splice(index, 1);
    //         }
    //     }
    // })
        // console.log(this.multipleFile,'tsts')
    },

    // downLoadMultiple(){
    // this.overlay = true;

    // const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
    // const s3 = new AWS.S3();

    // const downloadPromises = this.multipleFile.map((file) => {
    //     // console.log(file, 'file');

    //     return new Promise((resolve, reject) => {
    //         const params = {
    //             Bucket: bucketName,
    //             Key: file.path,
    //         };

    //         s3.getObject(params, (error, data) => {
    //             if (error) {
    //                 reject(error);
    //             } else {
    //                 // Instead of zipping, initiate download for each file
    //                 const blob = new Blob([data.Body], { type: data.ContentType });
    //                 const url = URL.createObjectURL(blob);
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.download = file.filename;
    //                 link.click();
    //                 resolve();
    //             }
    //         });
    //     });
    // });

    // Promise.all(downloadPromises)
    //     .then(() => {
    //         this.multipleFile = [];
    //         this.overlay = false;
    //         console.log('All files downloaded');
    //     })
    //     .catch((error) => {
    //         console.error('Error downloading files:', error);
    //     });


    // // const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
    // // const s3 = new AWS.S3();

    // // const downloadPromises = this.multipleFile.map((file) => {
    // //     return new Promise((resolve, reject) => {
    // //         const params = {
    // //             Bucket: bucketName,
    // //             Key: file.path
    // //         };

    // //         s3.getObject(params, (error, data) => {
    // //             if (error) {
    // //                 reject(error);
    // //             } else {
    // //                 // Create a Blob from the data
    // //                 const blob = new Blob([data.Body], { type: 'application/pdf' });

    // //                 // Create a URL for the Blob
    // //                 const url = URL.createObjectURL(blob);

    // //                 // Create a link element and simulate a click to download the file
    // //                 const link = document.createElement('a');
    // //                 link.href = url;
    // //                 link.download = file.filename;
    // //                 link.click();

    // //                 // Clean up the URL and resolve the promise
    // //                 URL.revokeObjectURL(url);
    // //                 resolve();
    // //             }
    // //         });
    // //     });
    // // });

    // // Promise.all(downloadPromises)
    // //     .then(() => {
    // //         this.overlay = false;
    // //     })
    // //     .catch((error) => {
    // //         console.error('Error downloading files:', error);
    // // });
    // },

    
    // downLoadMultiple(){
    //     AWS.config.update({
    //         region: "us-east-2",
    //         accessKeyId: process.env.MIX_AWS_ACCESS_KEY_ID,
    //         secretAccessKey: process.env.MIX_AWS_SECRET_ACCESS_KEY,
    //     });

    //     let s3 = new AWS.S3();

    //     this.overlay = true;
    //     const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
    //     // const s3 = new AWS.S3();

    //     const downloadPromises = this.multipleFile.map((file) => {
    //         console.log(file, 'file');

    //         return new Promise((resolve, reject) => {
    //             const params = {
    //                 Bucket: bucketName,
    //                 Key: file.path,
    //             };

    //             s3.getObject(params, (error, data) => {
    //                 if (error) {
    //                     reject(error);
    //                 } else {
    //                     // Instead of zipping, initiate download for each file
    //                     const blob = new Blob([data.Body], { type: data.ContentType });
    //                     const url = URL.createObjectURL(blob);
    //                     // const newTab = window.open(file.id,'_blank');
    //                     const link = document.createElement('a');
    //                     link.href = url;
    //                     link.download = file.filename;
    //                     link.click();
    //                     // resolve();
    //                     this.overlay = false;
    //                     this.multipleFile = [];
    //                     this.acceptBtn = true;
    //                     console.log('All files downloaded');

    //                 }
    //             });
    //         });
    //     });
    // },

    downLoadMultiple(){
        const toastId = this.$toast.info("Downloading! Please wait...", {
                timeout: 20000,
                // duration: 0, // Prevent auto-dismissal
                closeOnClick: false, // Optional: prevent closing on click
                pauseOnHover: true, // Optional: pause on hover
                closeButton: "button",
                icon: true,
                rtl: false
            });
        // Create an array to hold all download promises
        const downloadPromises = this.multipleFile.map(file => {
            const url = `/download-file?key=${encodeURIComponent(file.path)}`;
            return axios({
                url: url,
                method: 'GET',
                responseType: 'blob', // Important
            })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = file.filename; // Use the filename provided
                link.click();
                URL.revokeObjectURL(link.href); // Clean up the URL object
                this.$toast.success(`Successfully downloaded ${file.filename}`, {
                    style: {
                        width: '700px',
                        fontSize: '14px',
                        height: '85px',
                    }
                });
            })
            .catch(error => {
                console.error('Error downloading file:', error);
                // this.$toast.error(`Error downloading ${file.filename} : ${error.message} : PLEASE, RE-UPLOAD!`, {
                this.$toast.error(`Error downloading ${file.filename} : Please request to planner to re-upload the data.`, {
                    style: {
                        width: '710px',
                        height: '90px',
                    }
                });
            });
        });

        // Antayin matapos lahat ng downloads bago i-close kaya wag kang atat
        Promise.allSettled(downloadPromises)
            .finally(() => {
                // Dismiss the info toast after all downloads are complete
                this.$toast.dismiss(toastId);
            });
    },

    downLoadFile(id, type){
        this.overlay = true
        // axios.get(`download_figit push -le/${id}/${type}`,)
        // axios({
        //     method:'get',
        //     url:`download_file/${id}/${type}`,
        //     headers: {
        //         'Content-Type': 'application/json'
        //     }
        // }).then(()=>{
            window.open(`download_file/${id}/${type}`,"_blank")
            this.overlay = false
        // })
    },
    viewFile(id){
        this.overlay = true
            axios({
                method:'get',
                url:`open_file/${id}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(()=>{
                // console.log(data)
                window.open(`open_file/${id}`,"_blank").focus();
                this.overlay = false
            })
        },
    fileChange(tempVariable, col, vmod){

      // console.log(tempVariable, "temp")
        this[vmod] = [];
        if(tempVariable){
          // let a = tempVariable.filter((file) => file.size > 104857600)
            let a = tempVariable.reduce(( total, item) => {
                total += item.size;
                return total;
            }, 0)
          // console.log(a)
            if(a > 104857600){
                alert('file exceeded 1 mb')
                return false;
            }

        const readFile = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
                reader.readAsArrayBuffer(file);
            });
        }

        const getNumPages =async (file) => {
            const arrayBuffer = await readFile(file);
            const pdf = await PDFDocument.load(arrayBuffer);
            return pdf.getPages();
        }


        tempVariable.forEach(async (item) => {
            let numPages = 0;
            let splitFile = item.name.split('.')
            if(splitFile[splitFile.length - 1] == 'pdf'){
                numPages = await getNumPages(item);
                numPages = numPages.length;
            }
              // console.log(numPages.length, 'numPages');
            const reader = new FileReader();
            reader.readAsDataURL(item);
            // console.log(item)
            // if (tempVariable == "tempCsvFileImportBalcony") {
                reader.onloadend = () => {
                // const count = reader.result.match("/\/Page\W/");
                //     console.log(reader.result);
                this[vmod].push({
                    data: reader.result,
                    name: item.name,
                    column_name: col,
                    page_count : numPages
                });


                };

                // reader.readAsBinaryString(item);
                // reader.onloadend = () => {
                //     const count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
                //     console.log('Number of Pages:', count);
                // }
            // }
            })
        }

    },
    toggleDialogPreviousAttachmentForm(value){
        this.multipleFile = [];
        this.$emit('toggleDialogPreviousAttachmentForm', value)
    },
    // updateMerging(){
    //   // console.log(this.$store.state.editCadRequestRevisionContent)
    //   this.$emit('updateMerging', this.$store.state.editCadRequestRevisionContent)
    //   this.toggleDialogPreviousAttachmentForm(false)
    // },
    
        async updateMerging(){
            this.overlay = true;
            // console.log(this.editRecord, 'editRecord')
            this.countPageUpdate = 0;
            let downloadUrl = null;
            let id = this.$store.state.editCadRequestRevisionContent.id;
            await axios({
                method : 'GET',
                url : `update_merge/${id}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(async ({data}) => {
                // console.log(data, "dataaaaaaaaa")
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    // loop through the PDFs and add each one to the merged document
                    for (const pdf of data.fileBuffer) {
                    // decode the base64-encoded PDF
                        if(pdf){
                            const pdfBytes = Buffer.from(pdf, 'base64');
                            // create a PDFDocument object from the bytes
                            const pdfDoc = await PDFDocument.load(pdfBytes);
                            // loop through each page in the PDF and add it to the merged document
                            const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                pages.forEach((page) => {
                                    mergedPdf.addPage(page);
                                    this.countPageUpdate += 1;
                                });
                            }
                    
                            // save the merged PDF to a file
                            const mergedPdfBytes = await mergedPdf.save();
                            // Create a Blob object with the merged PDF data
                            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                            // Create a download URL for the Blob
                            downloadUrl = URL.createObjectURL(blob);
                            resolve(mergedPdfBytes)
                        }
                            // window.open(downloadUrl, '_blank');
                            // console.log(id, "merging id")
                            await this.saveUpdatedMergedFile(downloadUrl, id)
                            await this.updateMergeCadPira(data.cadPira,id);

                })
            })
        },
        saveUpdatedMergedFile(blobUrl, id){
            fetch(blobUrl)
                .then(response => response.blob())
                .then(blob => {
                    let rev1 = null;
                    let rev2 = null;
                    let explodeRevision = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
                    if(explodeRevision[0].length == 1){
                        rev1 = `0${explodeRevision[0]}`;
                    }else{
                        rev1 = explodeRevision[0]
                    }

                    if(explodeRevision[1].length == 1){
                        rev2 = `0${explodeRevision[1]}`;
                    }else if(explodeRevision[1].length == 2){
                        if(/[a-zA-Z]/.test(explodeRevision[1])){
                            rev2 = `0${explodeRevision[1]}`;
                        }else{
                            rev2 = explodeRevision[1];
                        }
                    }else{
                        rev2 = explodeRevision[1];
                    }
                    const file = new File([blob], 'merged.pdf');
                    this.pathName = this.$store.state.editCadRequestRevisionContent.customer_code;
                    this.mergedFilename = `${this.$store.state.editCadRequestRevisionContent.customer_code}-${rev1}${rev2}-`;

                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageUpdate);
                        formData.append('basic', JSON.stringify(this.basicInfo));
                        formData.append('cad', JSON.stringify(this.updateRecord));

                        axios({
                            method : "POST",
                            url : "api/update-merge",
                            data : formData
                        }).then(async ({data}) => {
                            // console.log(response, "res")
                            window.open(`open_file/${data.FileAttachment.id}`,"_blank");
                        })
                    })
        },
        updateMergeCadPira(data, id){
            this.countPageCadPira = 0;
            // let id = this.existingRevisions[index].id;
            let downloadUrl = null;
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    if(data){
                        // loop through the PDFs and add each one to the merged document
                        for (const pdf of data) {
                        // decode the base64-encoded PDF
                            if(pdf){
                                const pdfBytes = Buffer.from(pdf, 'base64');
                                // create a PDFDocument object from the bytes
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                // loop through each page in the PDF and add it to the merged document
                                const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                    pages.forEach((page) => {
                                        mergedPdf.addPage(page);
                                        this.countPageCadPira += 1;
                                    });
                                }
                        
                                // save the merged PDF to a file
                                const mergedPdfBytes = await mergedPdf.save();
                                // Create a Blob object with the merged PDF data
                                const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                                // Create a download URL for the Blob
                                downloadUrl = URL.createObjectURL(blob);
                                resolve(mergedPdfBytes)
                            }
                                await this.updateMergedCadPiraFile(downloadUrl, id)
                                // console.log(id, downloadUrl, "2")
                                
                    }else{
                        console.log(data, "no data")
                    }

                })
        },

        async updateMergedCadPiraFile(blobUrl, id){
            await fetch(blobUrl)
                .then(response => response.blob())
                .then(async blob => {
                    const file = new File([blob], 'merged.pdf');
                        let rev1 = null;
                        let rev2 = null;
                        let explodeRevision = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
                        if(explodeRevision[0].length == 1){
                            rev1 = `0${explodeRevision[0]}`;
                        }else{
                            rev1 = explodeRevision[0]
                        }

                        if(explodeRevision[1].length == 1){
                            rev2 = `0${explodeRevision[1]}`;
                        }else if(explodeRevision[1].length == 2){
                            if(/[a-zA-Z]/.test(explodeRevision[1])){
                                rev2 = `0${explodeRevision[1]}`;
                            }else{
                                rev2 = explodeRevision[1];
                            }
                        }else{
                            rev2 = explodeRevision[1];
                        }
                        this.pathName = this.$store.state.editCadRequestRevisionContent.customer_code;
                        this.mergedFilename = `${this.$store.state.editCadRequestRevisionContent.customer_code}-${rev1}${rev2}-`;

                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageCadPira);

                        await axios({
                            method : "POST",
                            url : "api/update-merge-cadpira",
                            data : formData
                        }).then(async response => {
                            // console.log(response, "res")
                            await setTimeout( async () => {
                                this.overlay = false;
                                this.toggleDialogPreviousAttachmentForm(false)
                                await this.$emit('getCadActualData');
                            }, 4000);


                        })
                    })

        },
    },
    watch: {
        '$store.state.previousAttachmentFiles'(val){
            console.log(val,'valval')
            this.updateRecord = this.$store.state.editCadRequestRevisionContent;
            this.basicInfo = this.$store.state.cadRequestBasicInformation;
            // console.log(this.updateRecord,'editCadRequestRevisionContent')
            // console.log(this.basicInfo,'cadRequestBasicInformation')
            this.repdfBtn = false;
            this.totalPages = 0;

            val.filter((r) => {
                if(r.filename.includes(r.customer_code)){
                    if(r.att_column_name == 'CAD依頼書結合ファイル'){
                        this.totalPages = r.no_of_pages
                        this.downloadBtn = true;
                        this.repdfBtn = true;
                        this.bossSchedBtn= true;
                    } else if(r.att_column_name != 'CAD依頼書結合ファイル') {
                        this.totalPages = r.no_of_pages
                    }
                    let type = r.filename.split('.')
                    r.fileType = type[type.length - 1];
                    return r
                }
            });

            val.filter((r) => {
                if(r.att_column_name == 'CAD依頼書結合ファイル'){
                    this.totalPages = r.no_of_pages
                    this.repdfBtn = true;
                } else if(r.att_column_name != 'CAD依頼書結合ファイル') {
                    this.totalPages = r.no_of_pages
                }

                let v = val.filter((item) => {
                    return item.att_column_name == 'CAD依頼書結合ファイル'
                });

                let g = val.filter((item) => {
                    return item.att_column_name == 'CAD依頼書';
                })
                // console.log(v,'CAD依頼書結合ファイル')
                // console.log(g,'CAD依頼書')
                if(v.length > 1 || g.length > 1){
                    this.repdfBtn = false;
                    this.downloadBtn = false;
                } else {
                    this.repdfBtn = true;
                    this.downloadBtn = true;
                }
            })
            const notExists = val.every(obj => !Object.values(obj).includes('CAD依頼書結合ファイル'));
            const notExistsCad = val.every(obj => !Object.values(obj).includes('CAD依頼書'));
            if(notExists || notExistsCad) this.repdfBtn = false;
            // console.log(this.repdfBtn, 'repdf')
                    // let values = [];
                    // let col = 'CAD依頼書結合ファイル';
                    // if(val.length > 0){
                    //     val.forEach(column => {
                    //         values.push(column.att_column_name)
                    //     });
                    // // console.log(values, 'values')

                    //       // success = docs.every(elem => values.includes(elem))
                    //       if (values.includes(col)) {
                    //         this.repdfBtn = false
                    //       }
                    // }
            val.filter((item) => {
                if(item.att_column_name == 'CAD依頼書結合ファイル' || (item.att_column_name == '現況図（CADデータ）' && this.$store.state.siteBoss != 'option1')){
                    if(item.selectedCheckBox = true){
                        this.multipleFile.push(item)
                    }else{
                        const index = this.multipleFile.findIndex(obj => obj.id === item.id);
                        this.multipleFile.splice(index, 1);
                    }
                } else if(item.fileType != 'pdf'){
                    // this.multipleFile.push(item)
                    item.selectedCheckBox = false;
                }
            })


        }
    },



};
</script>
<style lang="scss" scoped>
</style>
